import React from 'react';

type IStatesContext = {
	isOnline: boolean;
	error?: Error;
	setError: (error?: Error) => void;
};
export const statesContext = React.createContext<IStatesContext>({
	isOnline: window.navigator.onLine,
	setError: () => {},
});
